import type { DomainMapper } from '../types';

const base = {
  countryCode: 'se',
  currency: 'SEK',
  dataAreaId: 'se01',
  environment: 'production',
  flagUrl: '/flags/SE.svg',
  languagePrimary: true,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-se.xml',
  storyblokBasePath: 'se',
  algoliaIndex: 'b2b-se-sv-SE-products',
  algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1155,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1155,
    algoliaIndex: 'b2b-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-se.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1473,
    algoliaIndex: 'b2c-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2c-se-sv-SE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-se-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
  },
  showNonPublicProducts: false,
};

const se: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default se;
